import { TipPristupa } from '@kodit/core/data-api';

// Pristup strankama ima ko ih uredjuje ili radi sa dokumentima koji ih vezuju
export const STRANKA_CLAIMS: string[] = [
  TipPristupa[TipPristupa.STRANKA_CRUD],
  TipPristupa[TipPristupa.IZLAZNA_FAKTURA_VIEW],
  TipPristupa[TipPristupa.AVANSNI_RACUN_VIEW],
  TipPristupa[TipPristupa.IZMENA_OSNOVICE_VIEW],
  TipPristupa[TipPristupa.KOMPENZACIJA_VIEW],
  TipPristupa[TipPristupa.ULAZNA_FAKTURA_VIEW],
  TipPristupa[TipPristupa.PREDRACUN_VIEW],
  TipPristupa[TipPristupa.OTPREMNICA_VIEW],
  TipPristupa[TipPristupa.RADNI_NALOG_VIEW],
  TipPristupa[TipPristupa.FISKALNI_RACUN_VIEW],
  TipPristupa[TipPristupa.IZVOD_CRUD],
  TipPristupa[TipPristupa.IZVESTAJ_VIEW],
];
